/**
 * Syngrisi Plugin System - Core exports
 */

export { HookRegistry, hookRegistry } from './HookRegistry';
export { PluginManager, pluginManager } from './PluginManager';
export { loadPlugins, getPluginManager } from './PluginLoader';
export type { PluginLoaderConfig } from './PluginLoader';
